import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  sendMailRequest: ['email'],
  sendMailSuccess: null,
  getSessionRequest: null,
  getSessionSuccess: ['session'],
  getSessionFailure: ['error'],
  emailChanged: ['email'],
  logout: null,
});

export const RequestResetPasswordTypes = Types;
export default Creators;



// WEBPACK FOOTER //
// ./src/state/actions/RequestResetPasswordActions.js